const METRICS_DATA = [
  {
    value: 'impressions',
    label: 'Impressions',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#f15854' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#f15854',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['impressions']),
    currency: false
  },
  {
    value: 'clicks',
    label: 'Clicks',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#5da5da' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#5da5da',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['clicks']),
    currency: false
  },
  {
    value: 'unique_clicks',
    label: 'Unique Clicks',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#5fda21' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#5fda21',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['unique_clicks']),
    currency: false
  },
  {
    value: 'conversions',
    label: 'Conversions',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#82ca9d' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#82ca9d',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['conversions']),
    currency: false
  },
  {
    value: 'roi',
    label: 'ROI',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#0100a8' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#0100a8',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if (data.length !== 0 && _sumBy(data, (el) => el['cost']) !== 0) {
        if (_sumBy(data, (el) => el['total_revenue']) === undefined) {
          return result
        }
        result = `${(((_sumBy(data, (el) => el['total_revenue']) - _sumBy(data, (el) => el['cost'])) / _sumBy(data, (el) => el['cost'])) * 100).toFixed(2)}%`
      }
      return result
    },
  },
  {
    value: 'total_conversions',
    label: 'Total Actions',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ca2900' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ca2900',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['total_conversions']),
    currency: false
  },
  {
    value: 'transactions',
    label: 'Transactions',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#f19500' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#f19500',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['transactions']),
    currency: false
  },
  {
    value: 'epc',
    label: 'epc',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#8a391c' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#8a391c',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['total_revenue']) === undefined) {
          return result
        }
        result = `${((_sumBy(data, (el) => el['total_revenue']) / _sumBy(data, (el) => el['clicks']))).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'cost',
    label: 'Cost',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#000000' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#000000',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => `${(_sumBy(data, (el) => {
      return el['cost'] || 0
    })).toFixed(2)}`,
    currency: true
  },
  {
    value: 'profit',
    label: 'Profit',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#f100a9' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#f100a9',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['profit']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['profit'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'convtype1',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#e5e500' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ffff00',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype1']),
    currency: false
  },
  {
    value: 'convtype2',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ffc800' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ffc800',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype2']),
    currency: false
  },
  {
    value: 'convtype3',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff9b00' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff9b00',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype3']),
    currency: false
  },
  {
    value: 'convtype4',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff6200' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff6200',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype4']),
    currency: false
  },
  {
    value: 'convtype5',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff2f00' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff2f00',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype5']),
    currency: false
  },
  {
    value: 'convtype6',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff1d00' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff1d00',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype6']),
    currency: false
  },
  {
    value: 'convtype7',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ca002b' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ca002b',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype7']),
    currency: false
  },
  {
    value: 'convtype8',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#c70027' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#c70027',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype8']),
    currency: false
  },
  {
    value: 'convtype9',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff004e' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff004e',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype9']),
    currency: false
  },
  {
    value: 'convtype10',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ce004a' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ce004a',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype10']),
    currency: false
  },
  {
    value: 'convtype11',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ce004a' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ce004a',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype11']),
    currency: false
  },
  {
    value: 'convtype12',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ce004a' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ce004a',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype12']),
    currency: false
  },
  {
    value: 'convtype13',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ce004a' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ce004a',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype13']),
    currency: false
  },
  {
    value: 'convtype14',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ce004a' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ce004a',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype14']),
    currency: false
  },
  {
    value: 'convtype15',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ce004a' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ce004a',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype15']),
    currency: false
  },
  {
    value: 'convtype16',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ce004a' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ce004a',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype16']),
    currency: false
  },
  {
    value: 'convtype17',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ce004a' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ce004a',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype17']),
    currency: false
  },
  {
    value: 'convtype18',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ce004a' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ce004a',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype18']),
    currency: false
  },
  {
    value: 'convtype19',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ce004a' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ce004a',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype19']),
    currency: false
  },
  {
    value: 'convtype20',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ce004a' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ce004a',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => _sumBy(data, (el) => el['convtype20']),
    currency: false
  },
  {
    value: 'revenuetype1',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff00b4' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff00b4',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype1']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype1'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype2',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff00f9' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff00f9',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype2']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype2'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype3',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff00ff' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff00ff',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype3']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype3'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype4',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#d500ff' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#d500ff',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype4']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype4'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype5',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#a700ff' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#a700ff',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype5']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype5'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype6',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#9400ff' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#9400ff',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype6']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype6'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype7',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#5300ff' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#5300ff',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype7']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype7'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype8',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#0007cf' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#0007cf',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype8']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype8'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype9',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#f265f2' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#f265f2',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype9']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype9'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype10',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff97fa' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff97fa',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype10']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype10'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype11',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff97fa' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff97fa',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype11']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype11'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype12',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff97fa' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff97fa',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype12']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype12'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype13',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff97fa' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff97fa',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype13']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype13'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype14',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff97fa' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff97fa',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype14']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype14'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype15',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff97fa' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff97fa',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype15']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype15'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype16',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff97fa' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff97fa',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype16']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype16'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype17',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff97fa' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff97fa',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype17']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype17'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype18',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff97fa' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff97fa',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype18']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype18'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype19',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff97fa' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff97fa',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype19']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype19'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenuetype20',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#ff97fa' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#ff97fa',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenuetype20']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenuetype20'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'revenue',
    label: 'Revenue',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#8884d8' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#8884d8',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['revenue']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['revenue'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'total_revenue',
    label: 'Total Revenue',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#0042d8' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#0042d8',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        if (_sumBy(data, (el) => el['total_revenue']) === undefined) {
          return result
        }
        result = `${(_sumBy(data, (el) => el['total_revenue'])).toFixed(2)}`
      }
      return result
    },
    currency: true
  },
  {
    value: 'cr',
    label: 'Conversion rate',
    yaxisProperties: {
      type: 'number',
      tick: { fill: '#91f100' },
      allowDecimals: false,
    },
    lineChartProperties: {
      stroke: '#91f100',
      dot: { fill: '#ffffff', strokeWidth: 1 },
      strokeWidth: 2,
    },
    aggregator: (_sumBy, data) => {
      let result = 'N/A'
      if(data.length !== 0) {
        result = `${((_sumBy(data, (el) => el['total_conversions']) / _sumBy(data, (el) => el['clicks'])) * 100).toFixed(2)}%`
      }
      return result
    },
    currency: false
  },
]

const DASHBOARD_METRICS_LIST = ['metrics_A', 'metrics_B', 'metrics_C', 'metrics_D']

const DASHBOARD_BIGGEST_CHANGES_OPTIONS = [
  {
    value: 'yesterday_vs_day_before_yesterday',
  },
  {
    value: 'last_7_days_vs_previous_7_days',
  },
  {
    value: 'last_2_weeks_vs_previous_2_weeks',
  },
  {
    value: 'last_30_days_vs_previous_30_days',
  },
]

const DASHBOARD_GROUPING_OPTIONS = [
  {
    value: 'date',
  },
  {
    value: 'source',
    sharedAccessRights: 'sources',
  },
  {
    value: 'campaign',
    sharedAccessRights: 'campaigns',
  },
  {
    value: 'offer',
    sharedAccessRights: 'offers',
  },
  {
    value: 'network',
    sharedAccessRights: 'networks',
  },
]

const DASHBOARD_BIGGEST_CHANGE_DEF_GROUPING = ['date', 'campaign', 'source']
const DASHBOARD_EXCLUDE_METRICS = ['roi', 'profit', 'revenue', 'total_revenue']
const CONVERSION_DASHBOARD_SCOPE = 'conversion_dashboard'
const TRAFFIC_DASHBOARD_SCOPE = 'traffic_dashboard'

export {
  METRICS_DATA,
  DASHBOARD_GROUPING_OPTIONS,
  DASHBOARD_BIGGEST_CHANGES_OPTIONS,
  DASHBOARD_BIGGEST_CHANGE_DEF_GROUPING,
  DASHBOARD_METRICS_LIST,
  DASHBOARD_EXCLUDE_METRICS,
  CONVERSION_DASHBOARD_SCOPE,
  TRAFFIC_DASHBOARD_SCOPE,
}
